import React from 'react';
import MuiTypography, { TypographyProps as MuiTypographyProps } from '@mui/material/Typography';

/**
 * Design System Typography
 *
 * Use this instead of Tailwind typography utilities (text-*, font-*, etc.)
 * so typography decisions remain centralized and theme-driven.
 */
export type TypographyProps = MuiTypographyProps;

const DSTypography = React.forwardRef<React.ElementRef<typeof MuiTypography>, TypographyProps>(
  function DSTypography({ variant = 'body1', color, children, ...props }, ref) {
    return (
      <MuiTypography ref={ref} variant={variant} color={color} {...props}>
        {children}
      </MuiTypography>
    );
  },
);

export default DSTypography;
